module.exports = require("@bechtel/client-assets/dist/images/view-details.svg");